// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_of-5";
export var filledCircle = "_of-4";
export var historyEntry = "_of-3";
export var messageSideLeft = "_of-1";
export var messageSideRight = "_of-2";
export var orderTrackingCarouselWrapper = "_of-6";
export var orderTrackingInfoContainer = "_of-0";